// A sheet's All boards tile, loaded with its formula engine only when a sheet's tile is drawn, so the board's first
// load carries none of it. Its count is light, and here.

import { Suspense, lazy } from "react";
import type { Board, Entry } from "../../../shared/types";

const Real = lazy(() => import("./Thumb").then((m) => ({ default: m.SheetThumb })));

export function SheetThumb(props: { board: Board; entries: Entry[] }) {
  return (
    <Suspense fallback={<div className="ov-sheet" />}>
      <Real {...props} />
    </Suspense>
  );
}

/** What a sheet holds, counted, for its tile: "3 tabs" or "1 tab". */
export function sheetCount(entries: Entry[]): string {
  const n = entries.filter((e) => e.t === "sheet").length;
  return n === 1 ? "1 tab" : `${n} tabs`;
}
